<template>
  <!-- 商户信息管理，用于通联支付对接 -->
  <div class="defaultViewStyle">
    <el-tabs v-model="active" >
      <el-tab-pane v-for="(item) in checkTypeList" :key="item.userCode" :name="item.userCode" :label="item.dictName" lazy>
        <laborers-attendance-work v-if="item.userCode === 'WORK'" :check-name="item.dictName" :project-list="projectList" :site-list="siteList" :classmate-list="classmateList" :lot-list="lotList"/>
        <laborers-attendance-other v-else :type="item.userCode"  :check-name="item.dictName" :project-list="projectList" :site-list="siteList" :classmate-list="classmateList" :lot-list="lotList"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

import LaborersAttendanceWork from "@/views/h5/luqiao/laborers/attendance/result/LaborersAttendanceWork.vue";
import LaborersAttendanceOther from "@/views/h5/luqiao/laborers/attendance/result/LaborersAttendanceOther.vue";
import commonApi from "@/api/commonApi";
import Util from "@/util/util";
import {useRoute, useRouter} from "vue-router";
import commonLqApi from "@/api/dz-luqiao/luqiaoCommonApi";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "LA",
  components: {
    LaborersAttendanceWork, LaborersAttendanceOther
  },
  data() {
    return {
      active: "WORK",
      checkTypeList: [],
      projectList: [],
      siteList: [],
      classmateList: [],
      lotList: []
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  async created() {
    // 查询通用数据
    this.checkTypeList = await commonApi.queryDictionaryList("CLOCK_DEVICE");
    // 取第一个
    if (this.checkTypeList.length > 0) {
      this.active = this.checkTypeList[0].userCode;
    }
    this.projectList = await commonLqApi.queryProjectNoPage(); // 项目
    this.siteList = await commonLqApi.querySiteNoPage(); // 工地
    this.classmateList = await commonLqApi.queryClassmateNoPage(); // 施工班组
    this.lotList = await commonApi.queryDictionaryList("LOT"); // 标段
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/el-tabs";
</style>